/*
 * @Author: YanHSama haiyan.lin1@gientech.com
 * @Date: 2022-06-13 12:09:00
 * @LastEditors: YanHSama haiyan.lin1@gientech.com
 * @LastEditTime: 2022-06-20 17:55:16
 * @FilePath:
 * @Description:
 */
import React, { useState } from 'react';
// import Img404 from '@/assets/images/404.jpg';

import './index.less';
const newLoadingImg =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTggMTZBOCA4IDAgMSAxIDggMHYyYTYgNiAwIDEgMCA2IDZoMmE4IDggMCAwIDEtOCA4eiIgZmlsbD0iIzAwNmVmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+';

export default function VisiabledImg(props: any) {
  const { src, getImgIndex, flag } = props;

  const [needSrc, setNeedSrc] = useState(newLoadingImg);
  const [error, setError] = useState(false);
  // const [random, setRandom] = useState<number>();

  const onError = () => {
    setNeedSrc(newLoadingImg);
    setError(true);
  };
  const onLoad = (url: string) => {
    const img = new Image();
    img.src = url;
    img.onload = function () {
      setNeedSrc(url);
      setError(false);
    };
    img.onerror = () => {
      onError();
    };
  };

  const reLoad = (url: string) => {
    setError(false);
    getImgIndex(flag, Date.now());
  };

  if (error) {
    return (
      <div className="visiabled-img-fail">
        <span className="fail-text">Image loading failed.</span>
        <span className="fail-reload" onClick={() => reLoad(src)}>
          Reload
        </span>
      </div>
    );
  }

  return (
    <div
      className={`visiabled-img ${
        needSrc?.includes(newLoadingImg) ? 'visiabled-loading-img' : ''
      }  `}
    >
      <img
        className={`${needSrc?.includes(newLoadingImg) ? 'loading-icon' : ''}`}
        src={`${needSrc}`}
        alt=""
        onLoad={() => onLoad(src)}
        onError={onError}
      />
      {needSrc?.includes(newLoadingImg) ? <span className="loading-text">loading...</span> : null}
    </div>
  );
}
